import { render } from "./AddressList.vue?vue&type=template&id=bc7d0644&scoped=true&ts=true"
import script from "./AddressList.vue?vue&type=script&lang=ts"
export * from "./AddressList.vue?vue&type=script&lang=ts"

import "./AddressList.vue?vue&type=style&index=0&id=bc7d0644&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc7d0644"]])

export default __exports__